import { defineMessages } from 'react-intl';

export const scope = 'app.components.candidates.exam_details';

export default defineMessages({
  proview_assessment: {
    id: `${scope}.proview_assessment`,
    defaultMessage: 'Proview Assessment',
  },
  project_label: {
    id: `${scope}.project_label`,
    defaultMessage: 'Project',
  },
  project_name: {
    id: `${scope}.project_name`,
    defaultMessage: 'Advanced Calculus Final',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
});
